/* eslint-disable import/prefer-default-export */
export const getCampaignsReport = (state) => state.campaigns;

export const getCampaignReport = (tenantId, dimensions) => (state) => (
  state.campaigns.campaignsReport
  && state.campaigns.campaignsReport[tenantId]
  && state.campaigns.campaignsReport[tenantId][dimensions]
    ? state.campaigns.campaignsReport[tenantId][dimensions]
    : {});
